import ChartDatasets from "./datasets/dataset_helper"
import ChartOptions from "./options/options"
export default {
    name: "CapturesChartComponent",
    datasets: [],
    labels: "months",
    loading: true,
    options: ChartOptions.getCapturesChartOptions(),
    style:"height: 150px",
    config: {
        datasets:{
            today:{
                borderColor: "#a1704b",
            },
            yesterday:{
                borderColor: "#d2a17d",
            }
        }
        
    },
}